
import React, { useEffect, useState } from 'react'
import { useHistory } from 'react-router-dom'
import { API } from 'aws-amplify'
import StoryTitle from '../components/StoryTitle'
import StoryTable from '../components/StoryTable'
import color from '../shared/color'
import { ChoroplethUS, DonutChart, ScatterPlot, StackBarChart } from '../d3'
import { Typography, Grid, CircularProgress, Paper } from '@material-ui/core'
import { makeStyles } from '@material-ui/core/styles'
import '../story.css'

function DevOpsKPI_MeanTime() {

    const [title] = useState("Mean Time to Recovery (MTTR)")
    const [summary] =  useState("Key Performance Indicators of Software deployment and development in BD MMS for Mean Time to.")
    const [categories] = useState(["implementation"])
    const [isLoading, setIsLoading] = useState(true)
    const [data, setData] = useState(null)
    const [filterLayout] = useState([
        {column:"Column", field:"column_name"},
        {column:"Filter Value", field: "value_name"},
        {column:"Product Type",field:"producttype"}
    ])
    const [revLayout] = useState([
        {column:"Grouping Value", field:"grouping"},
        {column:"Result", field: "value_name"}
    ])
    const [tfsLayout] = useState([
        {column:"Established TFS Value", field:"tfsValue"}
    ])

    const [bubbleColor, setBubColor] = useState(null)
    const useStyles = makeStyles({
        table: {
            minWidth: 650,
        },
    })

    let history = useHistory()

    useEffect(() => {
        setBubColor(new Map([
            ["Scheduled_with_permission", "#4e79a7"],
            ["Customer_Managed", "#f28e2c"],
            ["Scheduled_wo_permission", "#59a14f"]
          ]))
        async function fetch() {
            await API.get('qs-web-api', '/data/DevOpsKPI_MeanTime/DevOpsKPI_MeanTime.json', {})
                .then((storyData) => {
                    setData(storyData)
                })
                .catch(function (error) {
                    console.log(error)
                })
            setIsLoading(false)
        }
        fetch()
    }, [])

    if (isLoading) {
        return (<div className="circular-progress"><CircularProgress disableShrink /></div>)
    } else {
        return (
            <div id="story">
                <StoryTitle title={title} date={data.date} categories={categories}></StoryTitle>

                <Paper className="storySection">
                    <Grid container justify="center" spacing={2} alignItems="stretch" >
                        <div className="subText">
                        <Typography >
                        <p>
                        MTTR is a key performance indicator that gauges your company''s efficiency in resolving issues. The ability to evaluate the business impact and customer experience repercussion provides insight needed to fully understand and prioritize problems. MTTR measures average recovery time from failure to resolution, and provides answers about whether customers lost access, experienced errors, or abandoned the application. Improving MTTR reduces impact of said problems, costs and protects customer satisfaction.
                        </p>
                        <p>
                        The main data source for MTTR is TFS issue tracking and Case data from Data Fusion.
                        </p>
                        <p>
                         <a href="/DevOpsKPI">Devops KPIs</a>
                         </p>

                        </Typography>
                        </div>
                    </Grid>
                </Paper>

                <Paper className="storySection">
                    <Grid container justify="center" spacing={2} alignItems="stretch">
                        <div className="description">
                            <Typography variant="h5" fontWeight="bold">
                                Customer Case Data MTTR
                            </Typography>
                        </div>
                    </Grid>
              </Paper>


              <Paper className="storySection">
                    <Grid container justify="center" spacing={2} alignItems="stretch">
                        <div className="description">
                            <Typography variant="h6" fontWeight="bold">
                            Case Data Time Spent By Product
                            </Typography>
                        </div>
                    </Grid>
                <Grid container justify="center" spacing={2} alignItems="stretch" >
<StackBarChart
                            data={data.stackedCaseDeviceTypeTimeSpent}
                            axis = {{y:"Number of Hours"}}
                            colors={["#42a5f5","#ba68c8","#ef5350","#ff9800","#4caf50","#1976d2","#9c27b0","#d32f2f","#ed6c02","#2e7d32"]}
                            tooltip={"Product"}
                            width={800}
                            height={400}>
                        </StackBarChart>
                </Grid>
                    <div className="subText">
                    <Typography>
                    <p>
                    Case data is focused on the product lines of ANESTHESIA ES,MEDSTATION ES and BD LOGISTICS.
                    </p>
                    <p>
                    Time spent on cases is a cost to the business on reactive work that impacts the customer operations. While the focus on the article is on MTTR, the overall time spent by the customer waiting for product fixes at a case level gives insight into downtime.
                    </p>
                    <p>
                    To request additional product lines reply on <a href="https://bddevops.atlassian.net/wiki/spaces/DEVOPS/pages/172359740/DevOps+KPI">Metric Development</a>.
                    </p>
                            </Typography>
                    </div>
                </Paper>

                <Paper className="storySection">
                    <Grid container justify="center" spacing={2} alignItems="stretch">
                        <div className="description">
                            <Typography variant="h6" fontWeight="bold">
                            Case Data Time Spent By Top 10 Problem Areas
                            </Typography>
                        </div>
                    </Grid>
                <Grid container justify="center" spacing={2} alignItems="stretch" >
<StackBarChart
                            data={data.stackedCasefailureProblemTypeTimeSpent}
                            axis = {{y:"Number of Hours"}}
                            colors={["#42a5f5","#ba68c8","#ef5350","#ff9800","#4caf50","#1976d2","#9c27b0","#d32f2f","#ed6c02","#2e7d32"]}
                            tooltip={"Problem Type"}
                            width={800}
                            height={400}>
                        </StackBarChart>
                </Grid>
                    <div className="subText">
                    <Typography>
                    <p>
                    Time consumed on solving issues for GCS on MMS products defined in the graphic above. Each problem is an impact that is downstream of the TFS issues.
                    </p>
                    <p>
                    The customer experience is changed by each time of downtime, future versions should look at reducing the overall time spent.
                    </p>
                    <p>
                    While the data system is not robust enough to track each specific issue to downtime, the product types give a high level view of where the customer experiance is weak.
                    </p>
                            </Typography>
                    </div>
                </Paper>


                <Paper className="storySection">
                    <Grid container justify="center" spacing={2} alignItems="stretch">
                        <div className="description">
                            <Typography variant="h6" fontWeight="bold">
                            Mean Time to Resolve (MTR), Task (MTT) and Insights (MTI) in the last year
                            </Typography>
                        </div>
                    </Grid>
                   <Grid container justify="center" spacing={2} alignItems="stretch">
                        <div className="subText">
                            <Typography>
                            </Typography>
                        </div>
                    </Grid>
                    <Grid container justify="center">
                        <ScatterPlot data={data.scatterMTValuesLastYear} axis={{x: "Data Extracted Date", y: "# of Days"}}
                                     width={900} height = {450} xType={"date"} yRange = {data.esyrangeMTValuesLastYear} tooltip = {"Number of Issues: "}
                                     colors = {["#d87015","#ee9090","#157DD8","#9090ee","#15d8d2","#d87015"]}></ScatterPlot>
                    </Grid>
                   <Grid container justify="center" spacing={2} alignItems="stretch">
                        <div className="subText">
                            <Typography>
                            <p>
                            Microsoft Team Foundation Server (TFS) holds all of the information on Issues. See <a href="https://bdlytics.stage.bdservices.io/tfscurrentstate">TFS Current State</a> for more information. While the data could evaluate all closed items during the current time, looking at the backlog gives a feel for the wait for customers.
                            </p>
                            <p>
                            MTR or Mean Time to Resolve is the age in days of all current issues that are unresolved.
                            </p>
                            <p>
                            MTI or Mean Time to Insights is the age in days of all current issues that are in active investigation.
                            </p>
                            <p>
                            MTT or Mean Time to Task is the age in days of all current issues with workitemtype task.
                            </p>
                            <p>
                            See <a href="https://bdlytics.stage.bdservices.io/tfscurrentstate">TFS Current State</a> for the parsing rules.
                            </p>
                            </Typography>
                          </div>
                    </Grid>
            </Paper>
            <Paper className="storySection">
                   <Grid container justify="center" spacing={2} alignItems="stretch">
                        <div className="subText">
                            <Typography>
                            Count of Issues and Tasks in MTT,MTI and MTR in the last year
                            </Typography>
                        </div>
                    </Grid>
                    <Grid container justify="center">
                        <ScatterPlot data={data.scatterMTValuesLastYearCounts} axis={{x: "Data Extracted Date", y: "# of Days"}}
                                     width={900} height = {450} xType={"date"} yRange = {data.esyrangeMTValuesLastYearCounts} tooltip = {"Number of Issues: "}
                                     colors = {["#d87015","#ee9090","#157DD8","#9090ee","#15d8d2","#d87015"]}></ScatterPlot>
                    </Grid>
                   <Grid container justify="center" spacing={2} alignItems="stretch">
                        <div className="subText">
                            <Typography>
                            <p>
                            See above graphic for definitions on MTT,MTI and MTR. Looking at the counts gives an indications of the backlog growth. See graphic below for the overall trend from the start of the TFS database.
                            </p>
                            <p>
                            Projects and goals can leave unresolved issues that have not resolved customer issues.
                            </p>
                            <p>
                            See the holistic count below for the total history. Medical device cases do not time out and need to be recorded for the full product lifecycle.
                            </p>
                            </Typography>
                        </div>
                    </Grid>
            </Paper>
            <Paper className="storySection">
                   <Grid container justify="center" spacing={2} alignItems="stretch">
                        <div className="subText">
                            <Typography>
                            Mean Time to Resolve (MTR), Task (MTT) and Insights (MTI)
                            </Typography>
                        </div>
                    </Grid>
                    <Grid container justify="center">
                        <ScatterPlot data={data.scatterMTValues} axis={{x: "Data Extracted Date", y: "# of Days"}}
                                     width={900} height = {450} xType={"date"} yRange = {data.esyrangeMTValues} tooltip = {"Number of Issues: "}
                                     colors = {["#d87015","#ee9090","#157DD8","#9090ee","#15d8d2","#d87015"]}></ScatterPlot>
                    </Grid>
                   <Grid container justify="center" spacing={2} alignItems="stretch">
                        <div className="subText">
                            <Typography>
                            <p>
                            The increase in average age is due to a large backlog. MTT does not have the same issue as MTI and MTR.
                            </p>
                            <p>
                            Microsoft Team Foundation Server (TFS) holds all of the information on Issues. See <a href="https://bdlytics.stage.bdservices.io/tfscurrentstate">TFS Current State</a> for more information. While the data could evaluate all closed items during the current time, looking at the backlog gives a feel for the wait for customers.
                            </p>
                            <p>
                            MTR or Mean Time to Resolve is the age in days of all current issues that are unresolved. See <a href="https://bdlytics.stage.bdservices.io/tfscurrentstate">TFS Current State</a> for the parsing rules.
                            </p>
                            <p>
                            MTI or Mean Time to Insights is the age in days of all current issues that are in active investigation. See <a href="https://bdlytics.stage.bdservices.io/tfscurrentstate">TFS Current State</a> for the parsing rules.
                            </p>
                            <p>
                            MTT or Mean Time to Task is the age in days of all current issues with workitemtype task.
                            </p>

                            </Typography>
                        </div>
                    </Grid>
            </Paper>
            <Paper className="storySection">
                    <Grid container justify="center" spacing={2} alignItems="stretch">
                        <div className="description">
                            <Typography variant="h6" fontWeight="bold">
                            Count of Issues and Tasks in MTT,MTI and MTR
                            </Typography>
                        </div>
                    </Grid>
                   <Grid container justify="center" spacing={2} alignItems="stretch">
                        <div className="subText">
                            <Typography>
                            </Typography>
                        </div>
                    </Grid>
                    <Grid container justify="center">
                        <ScatterPlot data={data.scatterMTValuesCounts} axis={{x: "Data Extracted Date", y: "# of Days"}}
                                     width={900} height = {450} xType={"date"} yRange = {data.esyrangeMTValuesCounts} tooltip = {"Number of Issues: "}
                                     colors = {["#d87015","#ee9090","#157DD8","#9090ee","#15d8d2","#d87015"]}></ScatterPlot>
                    </Grid>
                   <Grid container justify="center" spacing={2} alignItems="stretch">
                        <div className="subText">
                            <Typography>
                            <p>
                            April 2020 was a major effort to reduce the overall backlog.
                            </p>
                            <p>
                            See above graphic for definitions on MTT,MTI and MTR. Looking at the counts gives an indications of the backlog growth.
                            </p>
                            <p>
                            Microsoft Team Foundation Server (TFS) holds all of the information on Issues. See <a href="https://bdlytics.stage.bdservices.io/tfscurrentstate">TFS Current State</a> for more information. While the data could evaluate all closed items during the current time, looking at the backlog gives a feel for the wait for customers.
                            </p>
                            </Typography>
                        </div>
                    </Grid>
            </Paper>










            </div >
        )
    }
}

export default DevOpsKPI_MeanTime